import { AbconetApi } from '../General/AbconetApi';
import $ from "jquery";
import { useState } from 'react';
var formatMoney = require('../General/Helper').formatMoney;
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import AnimateOnChange from 'react-animate-on-change';
import { getStockInfo } from "./CartFunctions";


const arrayToObject = (array) =>
    array.reduce((obj, item) => {
        obj[item.newLine.stockcode] = item
            return obj
        },
        {});

export class CartSummary extends React.Component {

    constructor(props) {

        super(props);
  
        this.state = {
            cart: props.initial,
            showPopover: false,
            cartUpdateCollection: []
        }

    }

    componentDidMount() {
        $(document).on('CartUpdated', this.doUpdate.bind(this));
    }

    

    doUpdate(ev, cart) {
        if (cart == null) {
            AbconetApi.get('/api/cart').then(cart => {
                this.updateCart(cart);

            });
        } else {
            if (cart.id === -1) {
                this.updateCart(null);
  
            } else if (cart.id == this.state.cart.id) {
                this.updateCart(cart);
            }
        }
    }

    updateCart(newCart) {
        var existingCartLines = {};
        for (var i = 0; i < this.state.cart.lines.length; i++) {
            var line = this.state.cart.lines[i];
            existingCartLines[line.stockcode] = line;
        }

        if (newCart == null || newCart.lines == null) {
            return;
        }

        var updateCollectionMap = arrayToObject(this.state.cartUpdateCollection);


        newCart.lines.forEach((line) => {
            if (existingCartLines[line.stockcode] == null) {
                var timeout = setTimeout(() => this.removeCartUpdate(line.stockcode), 2000);

                updateCollectionMap[line.stockcode] = {
                    type: 'new',
                    newLine: line,
                    oldLine: null,
                    timeout
                }

            }
            else if (existingCartLines[line.stockcode].quantity != line.quantity) {
                var timeout = setTimeout(() => this.removeCartUpdate(line.stockcode), 2000);

                if (updateCollectionMap[line.stockcode]) {
                    clearTimeout(updateCollectionMap[line.stockcode].timeout);
                }
   
                updateCollectionMap[line.stockcode] = {
                    type: 'update',
                    newLine: line,
                    oldLine: existingCartLines[line.stockcode],
                    timeout
                };
            }
        });

        this.setState({ cart: newCart, showPopover: true, cartUpdateCollection: Object.values(updateCollectionMap) });
    }

    removeCartUpdate(stockcode) {
        var updateCollectionMap = arrayToObject(this.state.cartUpdateCollection);
        delete updateCollectionMap[stockcode];
        this.setState({ cartUpdateCollection: Object.values(updateCollectionMap) });
    }

    renderAddress() {
        if (this.state.cart == null) {
            return "No cart";
        }

        if (this.state.cart.pickupLocation) {
            return this.state.cart.pickupLocation.name;
        }

        if (this.state.cart.address == null) {
            return null;
        }

        return this.state.cart.address.name;
    }

    renderPopover() {
        var self = this;
        
        return (
            <div className="cart-popover">
                <ReactCSSTransitionGroup
                    transitionName="fade"
                    transitionEnterTimeout={2000}
                    transitionLeaveTimeout={2000}>
                    {this.state.cartUpdateCollection.map((item) => {

                        var lineTotal = formatMoney(item.newLine.lineTotal);
                        if (self.props.hidePrices) {
                            lineTotal = "";
                        }


                        return (
                            <div className="card" key={item.newLine.stockcode}>
                                <div className="card-body">
                                    <div className="row small-gutters">
                                        <div className="col-12 mb-2">
                                            {item.type == 'new' && <strong>Added to your cart.</strong>}
                                            {item.type == 'update' && <strong>Your cart has been updated.</strong>}
                                        </div>
                                    </div>
                                    <div className="row small-gutters">
                                        <div className="col-4 text-center">
                                            {(item.newLine != null && item.newLine.product != null) &&
                                                <img src={item.newLine.product.imageFileName} height="60" className="product-image" />
                                            }
                                        </div>
                                        <div className="col-8">
                                            <p className="description">{item.newLine.description}</p>
                                        </div>

                                    </div>
                                    <div className="row small-gutters mt-2">
                                        <div className="col-6">
                                            <span className="stockcode">Code: {item.newLine.stockcode}</span>
                                        </div>
                                        <div className="col-3">
                                            Qty: {item.newLine.quantity}
                                        </div>
                                        <div className="col-3">
                                            {lineTotal}
                                        </div>
                                    </div>

                                </div>
                            </div>
                                );
                    })}
                </ReactCSSTransitionGroup>
            </div>
        );
    }

    render() {
        if (this.state.cart == null) {
            return <div></div>;
        }

        var url = '/cart/' + this.state.cart.id;

        if (this.state.cart.id == 0) {
            url = '/cart/new/';
        }

      
        var total = formatMoney(this.state.cart.totalPrice + this.state.cart.totalTax);
        if (this.props.hidePrices) {
            total = "";
        }


        return (
            <div className="cart-summary">
  
                <a href={url} className="cart">
                    <AnimateOnChange
                        baseClassName="cart-update"
                        animationClassName="cart-update-enter"
                        animate={this.state.cartUpdateCollection.length > 0}></AnimateOnChange>

                    <div>
                        <div>{total}</div>
                        <div className="address">{this.renderAddress()}</div>
                    </div>
                    <i className="icon icon-cart"></i>
                </a>
               
                {this.renderPopover()}
            </div>
        );
    }

}